import { IResultStamp } from "@/api/AppApi/common-interfaces/IResultStamp";
export interface IKeyValue {
  key: string;
  value: string;
}
export interface IGetFiltersParams {
  q?: string;
  category_id?: number | string;
  brand_id?: number | string;
  external_id?: number | string;
}
export enum FilterKeys {
  price = "price",
  attributesArr = "attributes[]",
  brands = "brands",
}
export enum FilterTypes {
  range_slider = "range_slider",
  carousel = "carousel",
  checkbox = "checkbox",
  color_selector = "color_selector",
  tags = "tags",
  dropdown = "dropdown",
  images = "images",
}
export interface IFilter {
  type: "filter";
  configurations: {
    is_multi_select: boolean;
    key: string;
    min?: number;
    max?: number;
    title: string;
    type: FilterTypes;
  };
  data: IKeyValue[] | null;
}
export interface IGetFilters extends IResultStamp {
  result: IFilter[];
}
